import { IconInfoCircle, IconSparkles } from '@tabler/icons-react'
import { Tooltip } from 'antd'

import { Pill } from './BUI/Pill'
import { Text } from './BUI/Text'
import { Flexbox } from './Flexbox'

import { buildPassTheme } from 'src/styles/theme'

const AIDisclaimer =
  'AI-generated content is provided for informational purposes only and should not be relied upon as legal, safety, or professional advice. Always verify with a qualified expert.'

export const AIGeneratedPill = () => {
  return (
    <Tooltip title={AIDisclaimer}>
      <Pill
        label={
          <Flexbox alignItems="center" gap="0.5rem">
            This was generated by AI
            <IconInfoCircle size={16} style={{ cursor: 'pointer' }} />
          </Flexbox>
        }
        variant="ai"
        capitalise={false}
        icon={<IconSparkles size={16} />}
      />
    </Tooltip>
  )
}

export const SimpleAIGeneratedPill = () => {
  return (
    <Tooltip title={AIDisclaimer}>
      <Flexbox alignItems="center" justifyContent="center" gap="0.25rem">
        <IconInfoCircle
          size={16}
          style={{ marginBottom: '0.125rem' }}
          color={buildPassTheme.colour.secondary._500}
        />
        <Text variant="caption02" secondary="_500">
          AI Generated
        </Text>
      </Flexbox>
    </Tooltip>
  )
}
